<template>
  <span v-html="avatar" style="display: inline-block;"> </span>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
    import colors from "@/core/data/colors";
    const { uploadFile, upload } = useStorage();
export default defineComponent({
  props: {
    value: {
      type: Number,
      required: true,
    },
    src: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false,
    },
    size: {
      type: Number,
      required: false,
      default: 35,
    },
  },
  setup(props) {
    const config = useRuntimeConfig();
    const { users } = useSystemStore();
    const { $thumb } = useNuxtApp();
    const user = computed(() => {
      if (props.src || props.name) {
        return { fullName: props.name, avatar: props.src };
      }
      return users.find((user) => user.id === props.value);
    });
    const getAvatarByName = (
      name: string,
      backgroundColor?: string,
      size?: number
    ) => {
      let foregroundColor: string = "#000000";
      // if backgroundColor is missing
      // choose a random color from palette
      if (!backgroundColor) {
        backgroundColor = colors[Math.floor(Math.random() * colors.length)];
      }
      if (!size) size = 35;
      // selects the foregroundColor (black or white)
      // based on the backgroundColor
      const hex = backgroundColor.replace("#", "");
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      const hsp = Math.sqrt(
        0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b)
      );
      const theshold = 160;
      // sets the foreground color
      if (hsp > theshold) foregroundColor = "#000000";
      else foregroundColor = "#ffffff";
      // gets the user's name initial letters
      name = name.trim();
      if (name === "") {
        name = ":";
      } else {
        const d = name.toUpperCase().split(" ");
        const i = d.map((item) => {
          return item.substring(0, 1);
        });
        name = i.join("").substring(0, 2);
      }
      return `<span class="bearcms-user-avatar" style="color:${foregroundColor};background-color:${backgroundColor}; width:${props.size}px; height:${props.size}px" title='${user.value.fullName}'>${name}</span>`;
    };
    const avatar = computed(() => {
      if (!user.value) return "---";
      if (user.value.avatar)
        return `<img src='${$thumb(user.value.avatar, 200, 200)}' title='${user.value.fullName}' style="width: ${props.size}px;height:  ${props.size}px;border-radius: 50%;"/>`;
      return getAvatarByName(user.value.fullName);
    });

    return {
      avatar,
    };
  },
});
</script>
<style>
    .bearcms-user-avatar {
        display: inline-block;
        text-align: center;
        line-height: 35px;
        font-size: 14px;
        font-weight: 600;
        border-radius: 50%;
        margin-right: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
</style>
